import Swiper, { Navigation } from 'swiper';
import { swiperOnResize } from '../../utils/swiperOnResize.utils.js';

const initializedWrappers = new WeakSet();
const equalizersRegistry = new WeakMap();

const getSmallSectorsSlides = (swiperEl) => {
    return Array.from(
        swiperEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')
    );
};

const getSmallSectorsTitleGroups = (swiperEl) => {
    const titles = getSmallSectorsSlides(swiperEl)
        .map((slide) => slide.querySelector('.small-sectors-sec__item-title'))
        .filter(Boolean);

    return titles.length ? [titles] : [];
};

const setupSmallSectorsTitleEqualizer = (swiperEl) => {
    const equalizer = equalizersRegistry.get(swiperEl);

    if (equalizer) {
        equalizer.refresh();
        return;
    }

    if (typeof window.lineTitlesFunc !== 'function') {
        return;
    }

    equalizersRegistry.set(
        swiperEl,
        window.lineTitlesFunc([], {
            getGroups: () => getSmallSectorsTitleGroups(swiperEl),
        })
    );
};

const getSmallSectorsSwiperSettings = (nextEl, prevEl) => ({
    modules: [Navigation],
    observer: true,
    observeParents: true,
    slidesPerView: 1,
    spaceBetween: 20,
    threshold: 10,
    navigation: nextEl && prevEl ? {
        nextEl,
        prevEl,
    } : undefined,
});

const initSmallSectorsSwiper = (scope = document) => {
    const wrappers = scope.querySelectorAll('.small-sectors-swiper-wr');

    wrappers.forEach((wrapper) => {
        const swiperEl = wrapper.querySelector('.swiper');

        if (initializedWrappers.has(wrapper)) {
            if (swiperEl) {
                setupSmallSectorsTitleEqualizer(swiperEl);
            }

            return;
        }

        const nextEl = wrapper.querySelector('.swiper-button-next');
        const prevEl = wrapper.querySelector('.swiper-button-prev');
        const slidesCount = swiperEl?.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length ?? 0;

        if (!swiperEl || !slidesCount) {
            return;
        }

        initializedWrappers.add(wrapper);

        if (slidesCount > 4) {
            new Swiper(swiperEl, {
                ...getSmallSectorsSwiperSettings(nextEl, prevEl),
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 24,
                    },
                },
            });
        } else if (slidesCount === 4) {
            swiperOnResize('(max-width: 1023px)', swiperEl, {
                ...getSmallSectorsSwiperSettings(nextEl, prevEl),
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                },
            });
        } else {
            swiperOnResize('(max-width: 767px)', swiperEl, getSmallSectorsSwiperSettings(nextEl, prevEl));
        }

        setupSmallSectorsTitleEqualizer(swiperEl);
    });
};

initSmallSectorsSwiper();
